import { createSetting, useDialog } from '@shopex/finder'
import { MessageBox } from 'element-ui'
import { formatTimeStampToStr } from '@/utils/index'
import { batchDelete} from '../api'

export const tableSetting = (vm) => createSetting({
  columns: [
    { name: '服务单号', key: 'order_id', width: 170 },
    { name: 'ACM单号', key: 'acm_order_code', width: 170 },
    {
      name: '服务名称',
      key: 'item_name',
      minWidth: 150,
      render: (h, { row }) => {
        return row.item_info.item_name
      }
    },
    {
      name: '服务类型',
      key: 'source_type',
      minWidth: 150,
      render: (h, { row }) => {
        if(row.source_type) {
          return row.source_type == 'BUY_IN' ? '补购' : '续订'
        }
      }
    },
    {
      name: '购买金额',
      key: 'total_fee',
      minWidth: 100,
      render: (h, { row }) => {
        return row.original_fee / 100
      }
    },
    {
      name: '优惠金额',
      key: 'discount_fee',
      minWidth: 100,
      render: (h, { row }) => {
        return row.discount_fee / 100
      }
    },
    {
      name: '实付金额',
      key: 'original_fee',
      minWidth: 100,
      render: (h, { row }) => {
        return row.total_fee / 100
      }
    },
    {
      name: '绑定商品',
      key: 'bind_item',
      minWidth: 150,
    },
    {
      name: '绑定商品SN',
      key: 'bind_item_sn',
      minWidth: 150,
    },
    {
      name: '所属门店',
      key: 'shop_name',
      minWidth: 150,
      render: (h, { row }) => {
        return <div>
          <div>{row.shop_name}</div>
          <div style="color: #888;">AppID: {row.shop_code}</div>
        </div>
      }
    },
    {
      name: '绑定状态',
      key: 'bind_status_cn',
      minWidth: 150,
      render: (h, { row }) => {
        return <el-tag type={row.bind_status_cn_font}>{row.bind_status_cn}</el-tag>
      }
    },
    {
      name: '购买时间',
      key: 'pay_time',
      minWidth: 150,
      formatter: v => formatTimeStampToStr(v)
    },
  ],
  actions: [
    {
      name: '导出',
      slot: 'header',
      type: 'button',
      buttonType: 'primary',
      action: {
        handler: () => {
          vm.openExportDialog()
        }
      }
    },
    {
      name: '查看',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: async (rows) => {
          useDialog(null, {
            title: `补购记录详情`,
            width: '600px',
            orgData: rows[0],
            component: () => import('../comps/detail.vue')
          })
        }
      }
    }
  ]
})
